import axios from '@/utils/request'

/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API
}
export default {
  utils: {
    uploadFile: `${base.url}/analyse/util/uploadTemplate`
  },
  //账户概况
  accountAnalyseVn: {
    getData: `${base.url}/analyse/accountAnalyseVn/getData`,
    getAccountSurvey: `${base.url}/analyse/accountAnalyseVn/getAccountSurvey`,
    getDataActivate: `${base.url}/analyse/accountAnalyseVn/getDataActivate`,
    accountExport: `${base.url}/analyse/accountAnalyseVn/accountExport`,
    activateExport: `${base.url}/analyse/accountAnalyseVn/activateExport`
  },
  //存款概况
  chshinAnalyseVn: {
    getData: `${base.url}/analyse/chshinAnalyseVn/getData`,
    getDeposit: `${base.url}/analyse/chshinAnalyseVn/getDeposit`,
    depositExport: `${base.url}/analyse/chshinAnalyseVn/depositExport`,
    getDepositMoney: `${base.url}/analyse/chshinAnalyseVn/getDepositMoney`,
    depositMoneyExport: `${base.url}/analyse/chshinAnalyseVn/depositMoneyExport`
  },
  //取款概况
  chshoutAnalyseVn: {
    getData: `${base.url}/analyse/chshoutAnalyseVn/getData`,
    withdrawal: `${base.url}/analyse/chshoutAnalyseVn/withdrawal`,
    withdrawalExport: `${base.url}/analyse/chshoutAnalyseVn/withdrawalExport`,
    getPoorData: `${base.url}/analyse/chshoutAnalyseVn/getPoorData`,
    poor: `${base.url}/analyse/chshoutAnalyseVn/poor`,
    poorExport: `${base.url}/analyse/chshoutAnalyseVn/poorExport`
  },
  //交易概况
  realVn: {
    getData: `${base.url}/analyse/dealAnalyseVn/getData`,
    deal: `${base.url}/analyse/dealAnalyseVn/deal`,
    dealExport: `${base.url}/analyse/dealAnalyseVn/dealExport`,
    dealHand: `${base.url}/analyse/dealAnalyseVn/dealHand`,
    dealHandExport: `${base.url}/analyse/dealAnalyseVn/dealHandExport`,
    dealProduction: `${base.url}/analyse/dealAnalyseVn/dealProduction`,
    dealProductionExport: `${base.url}/analyse/dealAnalyseVn/dealProductionExport`
  },
  deviceVn: {
    vendor: `${base.url}/analyse/deviceRecord/deviceStatistical`,
    deviceList: `${base.url}/analyse/deviceRecord/deviceStatisticalList`,
    download: `${base.url}/analyse/deviceRecord/downloadDeviceStatistical`,
    analy: `${base.url}/analyse/deviceRecord/getDeviceRecordInfoAnaly`,
    detail: `${base.url}/analyse/deviceRecord/list`,
    export: `${base.url}/analyse/deviceRecord/export`,
    syndata: `${base.url}/analyse/deviceRecord/syndata`
  },
  //代理设置
  adAgent: {
    rebateSetList: `${base.url}/analyse/adAgent/rebateSet/list`,
    rebateSetDel: `${base.url}/analyse/adAgent/rebateSet/del`,
    rebateSetEdit: `${base.url}/analyse/adAgent/rebateSet/edit`,
    rebateSetDetail: `${base.url}/analyse/adAgent/rebateSet/detail`,
    rebateSetStatus: `${base.url}/analyse/adAgent/rebateSet/status`,
    rebateSetListAll: `${base.url}/analyse/adAgent/rebateSet/listAll`,
    symbolList: `${base.url}/analyse/adAgent/symbol/list`,
    symbolEdit: `${base.url}/analyse/adAgent/symbolConf/edit`,
    symbolHistory: `${base.url}/analyse/adAgent/symbolConf/history`,
    personnelList: `${base.url}/analyse/adAgent/personnel/list`,
    personnelDel: `${base.url}/analyse/adAgent/personnel/del`,
    personnelEdit: `${base.url}/analyse/adAgent/personnel/edit`,
    personnelStatus: `${base.url}/analyse/adAgent/personnel/status`,
    personnelCascader: `${base.url}/analyse/adAgent/personnel/cascader`,
    customerList: `${base.url}/analyse/adAgent/customer/list`,
    customerStatistics: `${base.url}/analyse/adAgent/customer/statistics`,
    customerDown: `${base.url}/analyse/adAgent/customer/down`,
    customerApplyImport: `${base.url}/analyse/adAgent/customerApply/import`,
    customerApplyList: `${base.url}/analyse/adAgent/customerApply/list`,
    customerApplyStatus: `${base.url}/analyse/adAgent//customerApply/status`,
    customerApplyDel: `${base.url}/analyse/adAgent//customerApply/del`,
    levelList: `${base.url}/analyse/adAgent/level/list`,
    rebateLevel: `${base.url}/analyse/adAgent/rebate/levels`,
    rebateDetailList: `${base.url}/analyse/adAgent/rebatedetail/list`,
    rebateDetailTotal: `${base.url}/analyse/adAgent/rebatedetail/total`,
    rebateDetailDown: `${base.url}/analyse/adAgent/rebatedetail/down`,
    personnelApplyList: `${base.url}/analyse/adAgent/personnelApply/list`,
    personnelApplyStatus: `${base.url}/analyse/adAgent/personnelApply/status`,
    personnelApplyDel: `${base.url}/analyse/adAgent/personnelApply/del`,
    rebateMonthProvide: `${base.url}/analyse/adAgent/rebateMonth/provide`,
    rebateMonthList: `${base.url}/analyse/adAgent/rebateMonth/list`,
    excludeCustomers: `${base.url}/analyse/adAgent/exclude/list`,
    delExcludeCustomers: `${base.url}/analyse/adAgent/exclude/del`,
    saveExcludeCustomers: `${base.url}/analyse/adAgent/exclude/add`
  },
  //沉睡客戶
  sleeping: {

    sleepingSynCustomers: `${base.url}/analyse/sleep/initByCustomerNumber`,
    frequencySynCustomers: `${base.url}/analyse/trading/initByCustomerNumber`,
    fundingSynCustomers: `${base.url}/analyse/funding/initByCustomerNumber`,
    loginInfoSynCustomers: `${base.url}/analyse/loginInfo/initByCustomerNumber`,


    sleepingList: `${base.url}/analyse/sleep/list`,
    sleepingDown: `${base.url}/analyse/sleep/down`,
    sleepingFollowImport: `${base.url}/analyse/sleep/followup/import`,
    sleepingFollowList: `${base.url}/analyse/sleep/followup/list`,
    sleepingFollowDown: `${base.url}/analyse/sleep/followup/down`,
    sleepingFollowInit: `${base.url}/analyse/sleep/followup/init`,

    frequencyList: `${base.url}/analyse/trading/frequency/list`,
    frequencyDown: `${base.url}/analyse/trading/frequency/down`,

    fundingList: `${base.url}/analyse/funding/list`,
    fundingDown: `${base.url}/analyse/funding/down`,


    loginInfoList: `${base.url}/analyse/loginInfo/list`,
    loginInfoDown: `${base.url}/analyse/loginInfo/down`,

    initByTime: `${base.url}/analyse/init/initByTime`,
    initByCustomerNumber: `${base.url}/analyse/init/customerNumbers`,
    initRecension: `${base.url}/analyse/init/recension`,
    initSchedule:`${base.url}/analyse/init/initSchedule`,
    initFiledValue:`${base.url}/analyse/init/initFiledValue`,


    callInfoList:`${base.url}/analyse/pbxInfo/list`,
    callInfoDown:`${base.url}/analyse/pbxInfo/down`,
    dedicatedImport:`${base.url}/analyse/pbxInfo/dedicated/import`,
    noteSave:`${base.url}/analyse/pbxInfo/note/save`,
    noteDel:`${base.url}/analyse/pbxInfo/note/del`,
    call:`${base.url}/analyse/pbxInfo/call`,
    hangup:`${base.url}/analyse/pbxInfo/hangup`,
    setPrefixes:`${base.url}/analyse/pbxInfo/cache/prefixes`,
    getPrefixes:`${base.url}/analyse/pbxInfo/prefixes`,
    getNoteInfo:`${base.url}/analyse/pbxInfo/note/info`,


    importInfoList:`${base.url}/analyse/pbxInfo/import/list`,
    importInfoImport:`${base.url}/analyse/pbxInfo/import/import`,
    importInfoDown:`${base.url}/analyse/pbxInfo/import/down`,
    importInfoDel:`${base.url}/analyse/pbxInfo/import/del`,
    importMobilePhone:`${base.url}/analyse/pbxInfo/import/mobilePhone`,


  },
  //短信管理
  sms: {
    templateList: `${base.url}/analyse/sms/template/list`,
    templateSave: `${base.url}/analyse/sms/template/save`,
    templateHide: `${base.url}/analyse/sms/template/hide`,
    scheduleList: `${base.url}/analyse/sms/schedule/list`,
    scheduleSave: `${base.url}/analyse/sms/schedule/save`,
    scheduleHide: `${base.url}/analyse/sms/schedule/hide`,
    scheduleExtractCustomer: `${base.url}/analyse/sms/schedule/extractCustomer`,
    autoScheduleList: `${base.url}/analyse/sms/autoSchedule/list`,
    autoScheduleSave: `${base.url}/analyse/sms/autoSchedule/save`,
    autoScheduleHide: `${base.url}/analyse/sms/autoSchedule/hide`,
    autoScheduleEnable: `${base.url}/analyse/sms/autoSchedule/enable`,
    autoScheduleDisable: `${base.url}/analyse/sms/autoSchedule/disable`,
    autoGroupList: `${base.url}/analyse/sms/autoGroup/list`,
    autoGroupSave: `${base.url}/analyse/sms/autoGroup/save`,
    autoGroupHide: `${base.url}/analyse/sms/autoGroup/hide`,
    autoGroupPreview: `${base.url}/analyse/sms/autoGroup/preview`,
    autoRuleList: `${base.url}/analyse/sms/autoGroupRule/list`,
    autoRuleOptions: `${base.url}/analyse/sms/autoGroupRule/listOptions`,
    autoRuleAccountTags: `${base.url}/analyse/sms/autoGroupRule/listAccountTags`,
    autoRuleAccountLevels: `${base.url}/analyse/sms/autoGroupRule/listAccountLevels`,
    autoRuleAccountStatuses: `${base.url}/analyse/sms/autoGroupRule/listAccountStatuses`,
    logList: `${base.url}/analyse/sms/log/list`,
    logBatchSave: `${base.url}/analyse/sms/log/batchSave`,
    logExtract: `${base.url}/analyse/sms/log/extractLog`,
  },
  // 客戶風險分析
  riskAnalyse: {
    queryByDays: `${base.url}/analyse/riskAnalyse/queryByDays`,
    queryByCustomerNumber: `${base.url}/analyse/riskAnalyse/queryByCustomerNumbers`,
    export: `${base.url}/analyse/riskAnalyse/export`
  }
}
